<template>
  <my-goods-page :initial-shop-type="7" :embedded="true" title="微店管理 - 我的商品" />
</template>

<script>
import MyGoodsPage from '../myGoods/index.vue'

export default {
  name: 'NewMyGoodsWechatPage',
  components: { MyGoodsPage }
}
</script>
